// extracted by mini-css-extract-plugin
export default {"actions":"IncidentsTable_actions_R5tY6"};